import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import * as fromTutorialVideos from './+state/tutorial-videos.reducer'
import { TutorialVideosEffects } from './+state/tutorial-videos.effects'
import { TutorialVideosFacade } from './+state/tutorial-videos.facade'

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromTutorialVideos.TUTORIAL_VIDEOS_FEATURE_KEY, fromTutorialVideos.tutorialVideosReducer),
    EffectsModule.forFeature([TutorialVideosEffects]),
  ],
  providers: [TutorialVideosFacade],
})
export class GbDashboardStaffDataAccessTutorialVideosModule {}
